import { Button, Input, Label } from '@kmgestao/ui';

export interface GenerateProspectLinkResultProps {
  url: string;
  copied: boolean;
  onCopy: () => void;
}

/**
 * Sub-view do `GenerateProspectLinkDialog` — tela de "link gerado"
 * com URL copiável + botão "Copiar" com feedback visual.
 *
 * Extraído para manter o componente pai ≤ 200 linhas (AGENTS.md §5.1).
 */
export function GenerateProspectLinkResult({
  url,
  copied,
  onCopy,
}: GenerateProspectLinkResultProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="prospect-generated-url">URL do formulário</Label>
        <div className="flex items-stretch gap-2">
          <Input
            id="prospect-generated-url"
            type="text"
            readOnly
            value={url}
            className="font-mono text-xs sm:text-sm"
            onFocus={(e) => e.target.select()}
          />
          <Button type="button" variant="outline" size="lg" onClick={onCopy}>
            {copied ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        Validade de 14 dias. O lead aparece no seu funil assim que submeter o formulário.
      </p>
    </div>
  );
}
